export { default } from "./ScoreVideoSync";
